import { render, staticRenderFns } from "./AllergyFields.vue?vue&type=template&id=4f36403a&scoped=true"
import script from "./AllergyFields.vue?vue&type=script&lang=js"
export * from "./AllergyFields.vue?vue&type=script&lang=js"
import style0 from "./AllergyFields.vue?vue&type=style&index=0&id=4f36403a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f36403a",
  null
  
)

export default component.exports